<template>
  <div>
    <div id="changePasswordModal" class="ui modal">
      <i class="close icon"></i>
      <div class="header">Change Password</div>
      <form class="ui form" action="javascript:void(0)">
        <div class="ui segment">
          <div class="field">
            <label>Old Password</label>
            <input id="oldPassword" type="password" v-model="oldPassword" placeholder="Current password" required="true" />
          </div>
          <password-input-pair ref="passwordPair" :password-label="'New Password'" v-model="password" />
          <div class="ui error message" />
        </div>
      </form>
      <div class="actions">
        <div class="ui black deny button">Cancel</div>
        <div class="ui positive button">Change Password</div>
      </div>
    </div>
    <div id="changePasswordFeedbackModal" class="ui modal">
      <div v-if="error" class="ui red header">Could not change your password</div>
      <div v-else class="header">Your password has been changed successfully</div>
      <div v-if="error" class="content">
        {{error}}
      </div>
      <div class="actions">
        <div class="ui black ok button">Close</div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordInputPair from '../PasswordInputPair'
import $ from 'jquery'
export default {
  components: {
    PasswordInputPair
  },
  data: function () {
    return {
      oldPassword: '',
      password: '',
      error: ''
    }
  },
  methods: {
    show: function () {
      $('#changePasswordModal').modal({
        onApprove: function () {
          $('#changePasswordModal').find('.ui.form').submit()
          return false
        },
        allowMultiple: true
      }).modal('show')
    }
  },
  mounted: function () {
    const fields = {
      oldPassword: {
        rules: [{
          type: 'empty',
          prompt: 'Please provide your current password'
        }]
      }
    }
    $.extend(fields, this.$refs.passwordPair.rules)
    const self = this
    $('#changePasswordModal').find('.ui.form').form({
      fields: fields,
      onSuccess: function () {
        const data = {
          oldPassword: self.oldPassword,
          newPassword: self.password
        }
        self.oldPassword = ''
        self.$refs.passwordPair.reset()
        self.$http.post('/api/auth/changepassword', data).then((response) => {
          self.error = ''
          $('#changePasswordFeedbackModal').modal('show')
        }, (response) => {
          self.error = response.body.message
          $('#changePasswordFeedbackModal').modal('show')
        })
      }
    })
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ChangePasswordModal.vue?8efe8764